import app from "app.controller"
import Filter from "components/Filter/Filter"
import ProductCol from "components/Product/ProductCard"
import SearchBarWithOptions from "components/Search/SearchBarWithOptions"
import Spinner from "components/Spinner/Spinner"
import PropTypes from "prop-types"
import shop from "shop/shop"

import queryString from "qs"
import React, { Component } from "react"
import { Card, Container } from "semantic-ui-react"
import historyStore from "stores/historyStore"
import productStore from "stores/productStore"
import { translateText } from "translate"
import searchStore from "stores/searchStore"
import ProductListItem from "../components/Product/ProductListItem";
import Responsive from "react-responsive"
import { SearchForm } from "../components/Search/SearchBarWithTypeahead";
import { trackSearch, trackSearchResults } from "components/tracking/Tracking";

export default class SearchPage extends Component {

  state = {
    query: {},
    products: []
  }

  handleSearch = (e = {}) => {
    let q = ""
    if (e.target && e.target.value) q = e.target.value
    if (e.q) q = e.q

    let query = this.state.query

    if (this.state.search !== e) {
      query.page = 1
    }

    this.setState({ search: q, query }, () => {
      if (q.length >= 3) {
        this.load()
      } else {
        this.setState({
          products: [],
          size: 0
        })
        return
      }
    })
  }

  onChangeFilter = (filter) => {
    this.updateQuery(filter)
  }

  addQuery(query) {
    this.props.history.replace(`${this.props.location.pathname}?${queryString.stringify(query)}`)
    return query
  }

  updateQuery({ page, dir, view, sort, pageSize }) {
    console.log("UPDATE QUERY")
    let query = this.state.query
    query.page = page || query.page
    query.dir = dir || query.dir
    query.count = pageSize || query.count
    query.sort = sort || query.sort
    query.q = this.state.search
    query.view = view || query.view

    this.addQuery(query)
    this.setState({ query }, () => {
      this.load()
    })
  }

  componentDidMount() {
    console.log("COMPONENT DID MOUNT")
    if (searchStore.searchTerm) {
      this.setState({ search: searchStore.searchTerm }, this.updateQuery({ page: 1 }))
    }
    let search = queryString.parse(this.props.location.search, { ignoreQueryPrefix: true })
    this.setState({
      loading: true,
      search: search.q || this.props.match.params.searchTerm || "",
      products: [],
      filter: {
        total: shop.config.standards.ITEMS_PER_PAGE,
        pageSize: shop.config.standards.ITEMS_PER_PAGE,
        currentPage: 1,
      },
      query: {
        q: search.q || "",
        sort: "article_nr",
        dir: shop.config.standards.DIR || null,
        page: search.page || 1,
        count: search.count || 10,
      }
    }, () => {
      this.load()
      app.search.change.add(this.handleSearch)
    })


  }

  load() {
    console.log("LOADING START")
    let { query } = this.state
    historyStore.set({
      link: `/search?q=${this.state.search}`,
      content: `${translateText("zurück zur Suche")}`,
    })

    let additionalFilters = []

    // if ( cmsStore.config.plugin.hideVariants ) {
    //   // FILTER ALL VARIANTS (ONLY MAIN-ARTCILES)
    //   let noVariants = {
    //     op:    "equals",
    //     field: "type",
    //     value: "1"
    //   }
    //   const singleItems = { "field": "mainArticle", "op": "equals", "value": "" }
    //   let combinedFilter = [{ "or": [singleItems, noVariants] }]
    //   additionalFilters = additionalFilters.concat( combinedFilter ) // this shows only mainarticles (i.e. no-variants))
    // }
    this.setState({ loading: true })

    productStore.search(this.state.search, {
      filter: additionalFilters,
      count: shop.config.standards.ITEMS_PER_PAGE,
      page: query.page,
      sort: query.sort || "search",
      dir: query.dir || shop.config.standards.DIR || "desc",
      artnr: 0
    }, { useArtNr: false })
      .then(response => {
        console.log("THIS STATE SEARCH")
        console.log(this.state)
        let { query } = this.state
        query.q = this.state.search
        let { products = [] } = response

        this.setState({
          size: response.size,
          products,
          loading: false
        })
        this.addQuery(query)
        if (this.state.search && this.state.search.length > 0) {
          trackSearch(this.state.search)
          trackSearchResults(this.state.search, response.size)
        }
      })
      .catch(err => {
        console.error(err)
        this.setState({ loading: false })
      })
      console.log("LOADING ENDE")
  }

  componentWillUnmount() {
    app.search.change.remove(this.handleSearch)
  }

  render() {

    let filter = {
      currentPage: Number(this.state.query.page),
      total: Number(this.state.size),
      brand: String(this.state.query.brand),
      pageSize: shop.config.standards.ITEMS_PER_PAGE,
      dir: this.state.query.dir || shop.config.standards.DIR || "desc",
      view: this.state.query.view || shop.config.standards.VIEW || "grid",
      sort: this.state.query.sort || "search"
    }

    const { loading } = this.state
    const { lastSearchURL } = productStore

    let filterSection = <section className="cf pb3">
      <Filter hidePageSize={true} onChange={this.onChangeFilter} {...filter} />
    </section>

    const { products } = this.state

    let backLink = shop._lastLocation || "/"

    return (
      <div className="SearchPage">

        <Container className={"pt4"}>

          <h1 className="b f1">{translate("Suche nach")} `{searchStore.searchTerm}`</h1>
          {/*<div className="flex flex-row justify-between items-top pt3">*/}
          {<Responsive maxWidth={790}>  <SearchBarWithOptions loading={loading} results={products} /></Responsive>}
          {<Responsive minWidth={790}>  <SearchBarWithOptions loading={loading} results={products} /></Responsive>}

          {/* */}
          {/*</div>*/}
          <div className="pt4-ns pt2">
            <div className={""}>

              {/*<div className="mw6 center">*/}
              {/*<SearchBar/>*/}
              {/*</div>*/}
              {this.state.size > 0 ? filterSection : null}
              {loading && <Spinner />}
              <section className="mb5">
                {!loading && <div>{(!loading && products && products.length > 0) ? null : <div
                  className="black-80 tc pa4">{translate("Keine Produkte gefunden.")}</div>}</div>}
                {!loading && <React.Fragment>
                  {(filter.view === "list") && <div>
                    {this.state.products.map(product => <ProductListItem
                      referrer={`/search/${location.search}`}
                      key={product.map_id} product={product} />)}
                  </div>}
                  {(filter.view === "grid") && <Card.Group itemsPerRow={4} doubling>
                    {this.state.products.map(product => <ProductCol
                      referrer={`/search/${location.search}`}
                      sm="1/2"
                      key={product.map_id}
                      product={product} />)
                    }
                  </Card.Group>
                  }
                </React.Fragment>}
              </section>
              <div className="pb4">
                {this.state.size > 0 ? filterSection : null}
              </div>
            </div>
          </div>
        </Container>
      </div>

    );
  }
}

SearchPage.propTypes = {
  params: PropTypes.object, filter: PropTypes.object, location: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/theme/mags/pages/SearchPage.js